// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"174":"35f5f870","522":"98686fe6"}[chunkId] + ".css";
};